// Shared helpers for building WhatsApp follow-up messages
import { formatIDR, formatDateID } from './format';

export const buildWhatsAppFollowupDue = ({ client_name, event_description, event_date, venue, invoice_number, outstanding_amount, payment_due_date }) => {
  return `Halo ${client_name || '-'}, selamat siang.

Kami dari Glowing Production ingin mengingatkan pembayaran untuk event:

Event: ${event_description || '-'}
Tanggal Event: ${formatDateID(event_date)}
Venue: ${venue || '-'}
Nomor Invoice: ${invoice_number || '-'}
Sisa Tagihan: ${formatIDR(outstanding_amount || 0)}
Jatuh Tempo: ${formatDateID(payment_due_date)}

Mohon dibantu update pembayarannya ya.
Terima kasih.`;
};

export const buildWhatsAppFollowupOverdue = ({ client_name, event_description, event_date, venue, invoice_number, outstanding_amount, payment_due_date, aging_days }) => {
  return `Halo ${client_name || '-'}, selamat siang.

Kami dari Glowing Production ingin follow-up pembayaran yang sudah jatuh tempo untuk event:

Event: ${event_description || '-'}
Tanggal Event: ${formatDateID(event_date)}
Venue: ${venue || '-'}
Nomor Invoice: ${invoice_number || '-'}
Sisa Tagihan: ${formatIDR(outstanding_amount || 0)}
Jatuh Tempo: ${formatDateID(payment_due_date)}
Aging: ${aging_days || 0} hari

Mohon dibantu informasinya kapan pembayaran bisa diproses.
Terima kasih.`;
};

export const buildWhatsAppQuotation = ({ client_name, event_description, event_date, venue, quotation_number, total_amount, valid_until_date }) => {
  return `Halo ${client_name || '-'}, selamat siang.

Berikut penawaran dari Glowing Production untuk:

Event: ${event_description || '-'}
Tanggal Event: ${formatDateID(event_date)}
Venue: ${venue || '-'}
Nomor Penawaran: ${quotation_number || '-'}
Total: ${formatIDR(total_amount || 0)}
Berlaku Hingga: ${formatDateID(valid_until_date)}

Mohon untuk direview. Terima kasih.`;
};

export const buildWhatsAppInvoice = ({ client_name, event_description, event_date, venue, invoice_number, invoice_amount, outstanding_amount, due_date, payment_instructions }) => {
  return `Halo ${client_name || '-'}, selamat siang.

Berikut invoice dari Glowing Production:

Event: ${event_description || '-'}
Tanggal Event: ${formatDateID(event_date)}
Venue: ${venue || '-'}
Nomor Invoice: ${invoice_number || '-'}
Jumlah Invoice: ${formatIDR(invoice_amount || 0)}
Sisa Tagihan: ${formatIDR(outstanding_amount || 0)}
Jatuh Tempo: ${formatDateID(due_date)}

${payment_instructions || ''}

Terima kasih.`;
};
